module.exports = __webpack_public_path__ + "static/media/mask (2).29397e4c.png";